const listeners = new Set();
let expirationNotified = false;

export const subscribeToAuthExpiration = (listener) => {
  listeners.add(listener);
  return () => listeners.delete(listener);
};

export const notifyAuthExpired = () => {
  if (expirationNotified) return;
  expirationNotified = true;
  listeners.forEach((listener) => listener());
};

export const resetAuthExpirationNotification = () => {
  expirationNotified = false;
};
